import { Ids } from 'ids';

import _replaceIds from '@bpmn-io/replace-ids';

const ids = new Ids([ 32, 36, 1 ]);


export default function replaceIds(template) {
  return _replaceIds(template, ids);
}